/**
 * sessionStorage封装
 */

export class StorageImpl {
    constructor() {
    };

    static getItem(key) {
        return window.sessionStorage.getItem(key);
    };

    static setItem(key, value) {
        window.sessionStorage.setItem(key, value);
        
    };

    static removeItem(key) {
        window.sessionStorage.removeItem(key);
    };

    static clear() {
        window.sessionStorage.clear();
    };

    static toJson(key) {
        var jsonObj = undefined;
        try {
            jsonObj = JSON.parse(StorageImpl.getItem(key)).data;
        } catch(e) {
        } finally {
            return jsonObj;
        }
    };

    static fromJson(key, value) {
        if (key == null) return false;
        var jsonObj = {};
        if (value != null)
            jsonObj.data = value;
        StorageImpl.setItem(key, JSON.stringify(jsonObj));
        return true;
    }
};

export class VuexStore {
    constructor() {
        this.state = {};
        this.getters = {};
        this.mutations = {};
        this.actions = {};
    }

    static storageValue(key, value) {
        return StorageImpl.fromJson(key, value);
    }

    static getValue(key) {
        return StorageImpl.toJson(key);
    }

    static removeValue(key) {
        return StorageImpl.removeItem(key);
    }

    /**
     * 添加vuex属性
     * @param {*} key       属性的key
     * @param {*} value     属性的默认值
     * @param {*} option    属性的option（getName：此属性getter名称，mutationName：此属性mutation名称，isStore：此属性是否缓存，用于F5刷新后的重置）
     */
    appendProperty(key, value, option) {
        if (key == null) return;
        this[key] = option;
        var _this = this;

        var getterName = null;
        var mutationName = null;
        if (option != null) {
            if (option.isStore) {
                var tmepValue = StorageImpl.toJson(key);
                if (tmepValue != null) value = tmepValue;
            }
            if (option.getName != null) getterName = option.getName;
            if (option.mutationName != null) mutationName = option.mutationName;
        }
        this.state[key] = value;

        if (getterName != null) {
            this.getters[getterName] = function(state) {
                return state[key];
            };
        }

        if (mutationName != null) {
            this.mutations[mutationName] = function(state, value) {
                if (!_this[key].isStore || VuexStore.storageValue(key, value)) {
                    state[key] = value;
                };
            };
        }
    };

    appendGetter(key, name, fun) {
        if (key == null) return;
        if (this[key] == null) return;
        if (this.getters[name] != null) return;
        var _this = this;
        this.getters[name] = function(state) {
            var temp = fun(state);
            return temp;
        }
    };

    appendMutation(key, name, fun) {
        if (key == null) return;
        if (this[key] == null) return;
        if (this.mutations[name] != null) return;

        var _this = this;
        this.mutations[name] = function() {
            var temp = fun.apply(this, arguments);
            if (_this[key].isStore) {
                StorageImpl.fromJson(key, _this[key]);
            }
        }
    };

    appendActions(name, fun) {
        if (this.actions[name] != null) return;

        var _this = this;
        this.actions[name] = fun;
    }
};



// WEBPACK FOOTER //
// ./src/core/storage/index.js